<template>
  
  <hero-slider/>
  <slot-static/>
  <!-- <modal-welcome-component/> -->
  <!-- <live-wagering/> -->
  <!-- <agent-button/> -->
</template>

<script>
  import HeroSlider from "@/components/hero-slider.vue"
  // import AgentButton from "@/components/agent-button.vue"
  // import LiveWagering from '@/components/live-wagering.vue'
  import SlotStatic from '@/components/slots-static.vue'
  // import ModalWelcomeComponent from '@/components/welcome-modal.vue'


  export default {
    name: "PageHome",
    components: {
      HeroSlider,
      SlotStatic,
      // ModalWelcomeComponent
      // AgentButton,
      // LiveWagering,
    },
    setup:() => {
    },
  }
</script>